module.exports = __webpack_public_path__ + "static/media/calendar.bac84002.svg";